// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import { BrowserRouter } from 'react-router-dom';
// import { ProjectProvider } from './ProjectContext';
// import reportWebVitals from './reportWebVitals';
// 
// const root = ReactDOM.createRoot(document.getElementById('root'));
// 
// // Log rendering details for debugging
// console.log('Rendering the root with BrowserRouter and ProjectProvider');
// 
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <ProjectProvider>
//         <App />
//       </ProjectProvider>
//     </BrowserRouter>
//   </React.StrictMode>
// );
// 
// reportWebVitals();

import { MotionConfig } from 'framer-motion';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
// FIX: Changed from a named import { SettingsProvider } to a default import
import SettingsProvider from './context/SettingsContext'; 
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SettingsProvider>
        <MotionConfig reducedMotion="user"><App /></MotionConfig>
      </SettingsProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
